/**
 * O banco de ideias de encontro, lido uma vez por aba.
 *
 * Vizinho do `academia.ts` e pelo mesmo motivo: lá o `DateIdeaService` abre o
 * `rootBundle` sozinho, aqui o arquivo mora em `public/dados/` e não dentro do
 * pacote. São 14 kB que só interessam a quem chega ao painel com o sorteio
 * ligado, e o caminho é relativo porque o `base: './'` do Vite serve o mesmo
 * bundle de `/` e de `/novo/`.
 */

import { Sorteio, bancoDeIdeias } from '@nosso-sempre/shared';

const ARQUIVO = 'dados/date_ideas_seed.json';

let pedido: Promise<Sorteio> | null = null;

/** A mesma promessa para todo mundo: o arquivo é buscado uma vez só. */
export function sorteio(): Promise<Sorteio> {
  pedido ??= fetch(new URL(ARQUIVO, document.baseURI))
    .then((r) => {
      if (!r.ok) throw new Error(`As ideias não vieram (${r.status}).`);
      return r.json();
    })
    .then((dados) => new Sorteio(bancoDeIdeias(dados)))
    .catch((err) => {
      // Sem isto, uma falha de rede deixaria a promessa rejeitada guardada e
      // toda tentativa seguinte falharia sem nem tentar de novo.
      pedido = null;
      throw err;
    });
  return pedido;
}
